import { render, staticRenderFns } from "./GeAttachmentEditDialog.vue?vue&type=template&id=6da98da0"
import script from "./GeAttachmentEditDialog.vue?vue&type=script&lang=js"
export * from "./GeAttachmentEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports